/**
 * Shows a floating "back to top" button once the page has been scrolled past
 * a merchant-configured percentage, and scrolls smoothly to top on click.
 */
function initBackToTopButton(button) {
  const thresholdPercent = Number(button.dataset.showThreshold) || 0;

  function updateVisibility() {
    const scrollable = document.body.scrollHeight - window.innerHeight;
    const scrolledPercent = scrollable > 0 ? (window.scrollY / scrollable) * 100 : 0;
    button.dataset.visible = String(scrolledPercent >= thresholdPercent);
  }

  button.addEventListener('click', () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });

  window.addEventListener('scroll', updateVisibility, { passive: true });
  updateVisibility();
}

document.querySelectorAll('.back-to-top').forEach(initBackToTopButton);
